import React from "react";
import { FiArrowUp } from "react-icons/fi";
import { LOCATION, NAME } from "../data/profile";

const Footer = () => (
    <footer className="flex flex-col gap-4 border-t border-fg/10 py-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="label leading-relaxed">
            © {new Date().getFullYear()} {NAME}
            <span className="mx-2 text-subtle">·</span>
            {LOCATION}
        </p>
        <a href="#top" className="group inline-flex items-center gap-2 text-fg">
            <span className="label link text-fg">Back to top</span>
            <FiArrowUp className="text-accent-text transition-transform duration-500 ease-out-expo group-hover:-translate-y-0.5" aria-hidden="true" />
        </a>
    </footer>
);

export default Footer;
